import React, { useState, useEffect, useRef, useMemo } from "react";
import { useDispatch } from "react-redux";
import { doctorActions } from "../../../core/actions";
import { roomMasterActions } from "../../../core/actions";
import TextField from "@mui/material/TextField";
import { Grid, List, FormControl, Button, Alert, Tooltip } from "@mui/material";
import Select from "react-select";
import { v4 as uuidv4 } from "uuid";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import useDynamicFontFormatter from "../../../shared/helper/useDynamicFontFormatter";
import { useOrganization } from "../../../configurations/OrganizationContext";

function PackageMasterAdd(props) {
  const dispatch = useDispatch();
  const org = useOrganization();
  const formatText = useDynamicFontFormatter(org?.fontStyle);

  const originalPackageServiceRef = useRef(null);

  const [packageDetail, setPackageDetail] = useState({
    name: "",
    type: "",
  });
  const [packageService, setPackageService] = useState({
    id: 0,
    name: "",
    productId: "",
    productName: "",
    packageid: "",
    packagetype: "",
    serviceType: "",
    description: "",
    amount: "",
    billable: true,
    isDoctor: "",
    gvId: 0,
    SpecificDoctor: false,
    packageServiceProduct: [],
    composite: "",
    compositeService: "",
  });
  const [ServerRes, setServerRes] = useState({ success: "", error: "" });
  const [formErrors, setFormErrors] = useState({
    name: "",
    serviceType: "",
    description: "",
  });
  const [packageList, setPackageList] = useState([]);
  const [doctorList, setDoctorList] = useState([]);
  const [luxurylevelList, setluxurylevelList] = useState([]);
  const [showLuxuryLevel, setShowLuxuryLevel] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [isReadonly, setIsReadonly] = useState(false);
  const [amount, setAmount] = useState(0);
  const [isDisabled, setIsDisabled] = useState(false);
  const [isClicked, setIsClicked] = useState(false);

  const [composite, setComposite] = useState(false);
  const [services, setServices] = useState({
    services: "",
  });

  const categories = useMemo(() => {
    if (org?.orgCode.toLowerCase() === "manaswini") {
      return [
        { id: 4, NAME: "LAB" },
        { id: 3, NAME: "PHARMACY" },
        { id: 1, NAME: "HMS" },
        { id: 7, NAME: "CONSULTATION" },
        { id: 6, NAME: "PANCHAKARMA" },
      ];
    }
    else if(org?.orgCode.toLowerCase() === "vedamaayu"){
       return [
      { id: 1, NAME: "HMS" },
      { id: 2, NAME: "PHARMACY" },
      { id: 3, NAME: "LAB" },
      { id: 4, NAME: "CUNSULTATION" },
     { id: 5, NAME: "TREATMENT" },
     { id: 6, NAME: "WELLNESS" },
     { id: 7, NAME: "SUBSCRIPTION" },
     
      
    ];

    }

    return [
      { id: 1, NAME: "LAB" },
      { id: 2, NAME: "X-RAY" },
      { id: 3, NAME: "ULTRASOUND" },
      { id: 4, NAME: "PHARMACY" },
      { id: 5, NAME: "SERVICES" },
      { id: 6, NAME: "CONSULTATION" },
    ];
  }, [org?.orgCode]);

  const selectStyles = {
    control: (base, state) => ({
      ...base,
      backgroundColor: state.isDisabled ? "#f5f5f5" : "#fff",
      borderColor: state.isFocused ? "#80bdff" : "#ccc",
      boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(0,123,255,.25)" : null,
      "&:hover": { borderColor: "#80bdff" },
    }),
    menu: (base) => ({ ...base, backgroundColor: "#fff", zIndex: 999 }),
  };

  useEffect(() => {
    getDoctorList();
    getPackages();
    getLuxuryLevelLists();

    if (props?.location?.state?.rowData) {
      const data = props.location.state.rowData;
      console.log("Edit data:", data);
      data["SpecificDoctor"] = data.gvId != null && data.gvId > 0;
      setPackageService(data);
      originalPackageServiceRef.current = JSON.parse(JSON.stringify(data));
      setIsReadonly(true);
      setEditMode(true);
    }
  }, []);

  const getPackages = () => {
    dispatch(
      doctorActions.getPackageList({}, (resCb) => {
        if (resCb?.packageList) setPackageList(resCb.packageList);
      }),
    );
  };

  const getDoctorList = () => {
    dispatch(
      doctorActions.getDoctorList({}, (resCb) => {
        if (resCb) {
          const filtered = resCb.filter(
            (doc) =>
              doc &&
              (doc.type.toLowerCase() === "doctor" ||
                doc.type.toLowerCase() === "counsellor"),
          );
          setDoctorList(filtered);
        }
      }),
    );
  };

  const getLuxuryLevelLists = () => {
    dispatch(
      roomMasterActions.getLuxuryLevelLists((resCb) => {
        if (resCb) setluxurylevelList(resCb.luxuryLevelLists);
      }),
    );
  };

  const handleInputChange = (name, value) => {
    if (name === "composite") {
      setComposite(value);
    }
    setFormErrors((prev) => ({ ...prev, [name]: "" }));
    setPackageService((prev) => {
      let newValue = value;

      // apply formatting only for name + description
      if (name === "name" || name === "description") {
        newValue = formatText(value); // ✔ formatted
      }

      // create updated object
      const updated = { ...prev, [name]: newValue };

      // isDoctor logic
      if (name === "isDoctor" && !value) {
        updated.SpecificDoctor = false;
      }

      return updated;
    });
    if (name == "name") {
      setShowLuxuryLevel(false);
    }
  };

  const packageDetailInput = (name, value) => {
    setPackageDetail((prev) => ({ ...prev, [name]: value }));
  };

  const applyAllAmount = () => {
    setIsClicked(true);
    if (!amount || amount <= 0) return;
    const updatedProducts = luxurylevelList.map((item) => {
      const existing = packageService.packageServiceProduct.find(
        (p) => p.luxurylevel === item.id,
      );
      return {
        luxurylevel: item.id,
        productName:
          existing?.productName ||
          `${packageService.name} - ${item.luxurylevel}`,
        productId: existing?.productId || null,
        amount,
      };
    });
    setPackageService((prev) => ({
      ...prev,
      packageServiceProduct: updatedProducts,
    }));

    setTimeout(() => setIsClicked(false), 1000);
  };

  const validateField = (fieldName, value) => {
    switch (fieldName) {
      case "name":
        return value ? "" : "Please Enter Package Name";
      case "serviceType":
        return value ? "" : "Please Enter Package Service Type";
      case "description":
        return value ? "" : "Please Enter description";
      default:
        return "";
    }
  };

  const handleSubmit = () => {
    const errors = {
      name: validateField("name", packageService.name),
      serviceType: validateField("serviceType", packageService.serviceType),
      description: validateField("description", packageService.description),
    };
    setFormErrors(errors);

    if (Object.values(errors).some((err) => err)) return;

    setIsDisabled(true);
    const productRequests = packageService.packageServiceProduct.map(
      (pkgProduct) => {
        const luxuryLevelObj = luxurylevelList.find(
          (ll) => ll.id === pkgProduct.luxurylevel,
        );
        const roomName = luxuryLevelObj
          ? luxuryLevelObj.luxurylevel
          : "Unknown";
        const productName =
          pkgProduct.productName || `${packageService.name} - ${roomName}`;
        const baseServiceCode = packageService.name
          .replace(/\s+/g, "_")
          .toUpperCase();
        const ServiceCode = `${baseServiceCode}_${
          pkgProduct.luxurylevel
        }_${uuidv4().substring(0, 8)}`;

        return {
          m_sName: productName,
          m_DisplayName: productName,
          m_iCategoryID:
            categories.find((cat) => cat.NAME === packageService.serviceType)
              ?.id || 0,
          altcode: ServiceCode,
          categoryName: packageService.serviceType,
          serviceName: packageService.name,
          description: packageService.description || packageService.name,
          productType: 8,
          trackinventory: false,
         // m_TaxInfo: { m_iID: 2 },
         m_TaxInfo: { m_iID: 0 },
          priceInfo: {
            pricebuy: 0.0,
            pricesell:
              parseFloat(pkgProduct.amount) ||
              parseFloat(packageService.amount) ||
              0.0,
          },
        };
      },
    );

    const payload = { ...packageService, productRequests };
    const action =
      packageService.id > 0
        ? doctorActions.updateService
        : doctorActions.addService;

    dispatch(
      action([payload], (resCb) => {
        if (resCb) {
          setServerRes({ success: "Service saved successfully" });
          setTimeout(() => props.history.push("/packageList"), 2000);
        }
      }),
    );
  };

  const isDirty = useMemo(() => {
    if (!editMode) return true;
    if (!originalPackageServiceRef.current) return false;
    return (
      JSON.stringify(packageService) !==
      JSON.stringify(originalPackageServiceRef.current)
    );
  }, [packageService, editMode]);

  // ✅ Updated handleSave to match your requirement
  const handleSave = () => {
    if (!showLuxuryLevel) {
      if (!editMode) {
        const hasName = packageDetail.name?.trim();
        const hasType = packageDetail.type?.trim();

        if (hasName && hasType) {
          // ✅ Save package, but DO NOT go to Step 2
          dispatch(
            doctorActions.addPackage(packageDetail, (resCb) => {
              if (resCb?.successMessages) {
                setServerRes({ success: "Package saved successfully" });
                setTimeout(() => {
                  closeAlert();
                  toggle();
                }, 3000);
              } else {
                setServerRes({ error: "Failed to save package" });
                setTimeout(() => {
                  closeAlert();
                  toggle();
                }, 3000);
              }
            }),
          );
        } else {
          // Edit mode: go to Step 2
          proceedToStep2();
        }
      } else {
        // Edit mode: go to Step 2
        proceedToStep2();
      }
    } else {
      handleSubmit();
    }
  };

  const proceedToStep2 = () => {
    const errors = {
      name: validateField("name", packageService.name),
      serviceType: validateField("serviceType", packageService.serviceType),
      description: validateField("description", packageService.description),
    };
    setFormErrors(errors);

    if (!errors.name && !errors.serviceType && !errors.description) {
      let updatedProducts = [];

      // Only preserve existing products if in edit mode
      if (editMode && packageService.packageServiceProduct) {
        updatedProducts = [...packageService.packageServiceProduct];
      }

      // If no products and luxury levels exist, auto-generate
      if (updatedProducts.length === 0 && luxurylevelList.length > 0) {
        updatedProducts = luxurylevelList.map((item) => ({
          luxurylevel: item.id,
          productName: `${packageService.name} - ${item.luxurylevel}`,
          productId: null,
          amount: amount || 0,
        }));
      }

      setPackageService((prev) => ({
        ...prev,
        packageServiceProduct: updatedProducts,
      }));

      setShowLuxuryLevel(true);
    }
  };
  const closeAlert = () => {
    setServerRes({ success: "", error: "" });
  };
  const toggle = () => props.history.push("/packageList");

  return (
    <>
      {ServerRes.success && (
        <Alert severity="success">{ServerRes.success}</Alert>
      )}
      {ServerRes.error && <Alert severity="error">{ServerRes.error}</Alert>}

      <main className="mainsection">
        {!editMode && <h5 className="mx-2">Add Packages</h5>}
        <List>
          <div className="p-2 bg-none">
            <form>
              {!editMode && (
                <Grid container spacing={2}>
                  <Grid item md={6}>
                    <TextField
                      className="py-2"
                      fullWidth
                      label="Package Name"
                      value={packageDetail.name}
                      onChange={(e) =>
                        packageDetailInput("name", e.target.value)
                      }
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item md={6}>
                    <TextField
                      className="py-2"
                      fullWidth
                      label="Package Type"
                      value={packageDetail.type}
                      onChange={(e) =>
                        packageDetailInput("type", e.target.value)
                      }
                      variant="outlined"
                    />
                  </Grid>
                </Grid>
              )}
              <div className="mt-3 mb-3">
                <h5>{editMode ? "Edit Service" : "Add Service"}</h5>
              </div>
              {/* Step 1: Basic Info */}
              <Grid container spacing={2}>
                <Grid item md={4}>
                  <TextField
                    className="py-2"
                    fullWidth
                    label="Package Service Name"
                    value={packageService.name}
                    onChange={(e) => handleInputChange("name", e.target.value)}
                    helperText={
                      <span style={{ color: "#EC4147" }}>
                        {formErrors.name}
                      </span>
                    }
                    variant="outlined"
                    disabled={isReadonly}
                  />
                </Grid>
                <Grid item md={4}>
                  <FormControl fullWidth className="py-2">
                    <Select
                      name="serviceType"
                      value={
                        categories
                          .map((cat) => ({ value: cat.NAME, label: cat.NAME }))
                          .find(
                            (opt) => opt.value === packageService.serviceType,
                          ) || null
                      }
                      onChange={(opt) =>
                        handleInputChange("serviceType", opt?.value || "")
                      }
                      isClearable
                      isSearchable
                      options={categories.map((cat) => ({
                        value: cat.NAME,
                        label: cat.NAME,
                      }))}
                      placeholder="--- Select Service Type ---"
                      isDisabled={isReadonly}
                      styles={selectStyles}
                    />
                    {formErrors.serviceType && (
                      <span
                        style={{
                          color: "#EC4147",
                          fontSize: "0.75rem",
                          marginLeft: "14px",
                        }}
                      >
                        {formErrors.serviceType}
                      </span>
                    )}
                  </FormControl>
                </Grid>
                <Grid item md={4}>
                  <FormControl fullWidth className="py-2">
                    <Select
                      name="packageid"
                      value={
                        packageList
                          .map((pack) => ({ value: pack.id, label: pack.name }))
                          .find(
                            (opt) => opt.value === packageService.packageid,
                          ) || null
                      }
                      onChange={(opt) =>
                        handleInputChange("packageid", opt?.value || "")
                      }
                      isClearable
                      isSearchable
                      options={packageList.map((pack) => ({
                        value: pack.id,
                        label: pack.name,
                      }))}
                      placeholder="--- Select Package ---"
                      isDisabled={isReadonly}
                      styles={selectStyles}
                    />
                  </FormControl>
                </Grid>
              </Grid>

              <Grid container spacing={2}>
                <Grid item md={4}>
                  <TextField
                    className="py-2"
                    fullWidth
                    label="Description"
                    value={packageService.description}
                    onChange={(e) =>
                      handleInputChange("description", e.target.value)
                    }
                    helperText={
                      <span style={{ color: "#EC4147" }}>
                        {formErrors.description}
                      </span>
                    }
                    variant="outlined"
                  />
                </Grid>
                <Grid item md={8}>
                  <div className="d-flex align-items-center mt-3">
                    <label className="d-flex align-items-center me-4">
                      <input
                        type="checkbox"
                        checked={packageService.billable === true}
                        disabled={isReadonly}
                        onChange={(e) =>
                          handleInputChange("billable", e.target.checked)
                        }
                      />
                      <span className="ms-1">Billable</span>
                    </label>

                    <label className="d-flex align-items-center me-4">
                      <input
                        type="checkbox"
                        id="composite"
                        checked={
                          packageService.composite === true ||
                          packageService.composite === "true"
                        }
                        onChange={(e) =>
                          handleInputChange("composite", e.target.checked)
                        }
                      />
                      <span className="ms-1">Composite</span>
                    </label>
                    {packageService.billable && (
                      <>
                        <label className="d-flex align-items-center me-4">
                          <input
                            type="checkbox"
                            checked={
                              packageService.isDoctor == true ||
                              packageService.isDoctor == "true"
                            }
                            disabled={isReadonly}
                            onChange={(e) =>
                              handleInputChange("isDoctor", e.target.checked)
                            }
                          />
                          <span className="ms-1">IsDoctor</span>
                        </label>
                        {packageService.isDoctor && (
                          <label className="d-flex align-items-center">
                            <input
                              type="checkbox"
                              checked={
                                packageService.SpecificDoctor == true ||
                                packageService.SpecificDoctor == "true"
                              }
                              disabled={isReadonly}
                              onChange={(e) =>
                                handleInputChange(
                                  "SpecificDoctor",
                                  e.target.checked,
                                )
                              }
                            />
                            <span className="ms-1">SpecificDoctor</span>
                          </label>
                        )}
                      </>
                    )}
                  </div>
                </Grid>
              </Grid>
              {(packageService.composite || packageService.SpecificDoctor) && (
                <Grid container spacing={2}>
                  {packageService.composite && (
                    <Grid item md={4} id="packagemasteradd">
                      <TextField
                        fullWidth
                        className="py-2"
                        id="services"
                        value={
                          packageService.compositeService
                            ? packageService.compositeService.replaceAll(
                                "\\n",
                                "\n",
                              )
                            : ""
                        }
                        placeholder={`ALL SERVICES:\nLABSERVICES:`}
                        label="Services"
                        variant="outlined"
                        autoComplete="off"
                        multiline
                        minRows={2}
                        onChange={(event) =>
                          handleInputChange(
                            "compositeService",
                            event.target.value,
                          )
                        }
                      />
                    </Grid>
                  )}
                  {packageService.SpecificDoctor && packageService.isDoctor && (
                    <Grid item md={4}>
                      <FormControl fullWidth className="py-2">
                        <Select
                          name="doctor"
                          value={
                            doctorList
                              .map((doc) => ({
                                value: doc.gvId,
                                label: `${doc.displaytitle}${doc.first_name} - ${doc.qualification} - ${doc.department}`,
                              }))
                              .find(
                                (opt) => opt.value === packageService.gvId,
                              ) || null
                          }
                          onChange={(opt) =>
                            handleInputChange("gvId", opt?.value || "")
                          }
                          isClearable
                          isSearchable
                          options={doctorList.map((doc) => ({
                            value: doc.gvId,
                            label: `${doc.displaytitle}${doc.first_name} - ${doc.qualification} - ${doc.department}`,
                          }))}
                          placeholder="--- Select Doctor ---"
                          isDisabled={isReadonly}
                          styles={selectStyles}
                        />
                      </FormControl>
                    </Grid>
                  )}
                </Grid>
              )}
              <Grid container spacing={2}>
                <Grid item md={3}>
                  <TextField
                    className="py-2"
                    fullWidth
                    label="Charges/Fee"
                    type="number"
                    value={amount}
                    disabled={!packageService.billable}
                    onChange={(e) => setAmount(parseFloat(e.target.value) || 0)}
                    variant="outlined"
                  />
                </Grid>
                <Grid
                  item
                  md={2}
                  className="d-flex align-items-end"
                  style={{ padding: "10px" }}
                >
                  <Tooltip title="Apply to all luxury levels">
                    <Button
                      variant="contained"
                      color={isClicked ? "success" : "primary"} // change color on click
                      onClick={applyAllAmount}
                      disabled={!packageService.billable}
                    >
                      <DoneAllIcon />
                    </Button>
                  </Tooltip>
                </Grid>
              </Grid>

              {showLuxuryLevel && (
                <Grid container spacing={2} className="pt-3">
                  {luxurylevelList.map((item) => (
                    <Grid
                      container
                      item
                      spacing={2}
                      md={12}
                      key={item.id}
                      alignItems="center"
                    >
                      <Grid item md={4}>
                        <TextField
                          className="py-1"
                          fullWidth
                          label={`LuxuryLevel - ${item.luxurylevel}`}
                          value={`LuxuryLevel - ${item.luxurylevel}`}
                          disabled
                          variant="outlined"
                        />
                      </Grid>
                      <Grid item md={4}>
                        <TextField
                          className="py-1"
                          fullWidth
                          label="Product Name"
                          value={
                            packageService.packageServiceProduct.find(
                              (p) => p.luxurylevel === item.id,
                            )?.productName ||
                            `${packageService.name} - ${item.luxurylevel}`
                          }
                          onChange={(e) => {
                            const updated =
                              packageService.packageServiceProduct.map((p) =>
                                p.luxurylevel === item.id
                                  ? { ...p, productName: e.target.value }
                                  : p,
                              );
                            setPackageService((prev) => ({
                              ...prev,
                              packageServiceProduct: updated,
                            }));
                          }}
                          variant="outlined"
                          disabled={true}
                        />
                      </Grid>
                      <Grid item md={4}>
                        <TextField
                          className="py-1"
                          fullWidth
                          label="Amount"
                          type="number"
                          value={
                            packageService.packageServiceProduct.find(
                              (p) => p.luxurylevel === item.id,
                            )?.amount || 0
                          }
                          onChange={(e) => {
                            const updated =
                              packageService.packageServiceProduct.map((p) =>
                                p.luxurylevel === item.id
                                  ? {
                                      ...p,
                                      amount: parseFloat(e.target.value) || 0,
                                    }
                                  : p,
                              );
                            setPackageService((prev) => ({
                              ...prev,
                              packageServiceProduct: updated,
                            }));
                          }}
                          variant="outlined"
                        />
                      </Grid>
                    </Grid>
                  ))}
                </Grid>
              )}

              {/* Buttons */}
              <div
                className="buttonsetconfirm"
                style={{
                  marginTop: "24px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                  gap: "12px",
                }}
              >
                <Button
                  variant="contained"
                  color="error"
                  onClick={toggle}
                  style={{ textTransform: "none" }}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSave}
                  disabled={showLuxuryLevel ? isDisabled || !isDirty : false}
                >
                  {showLuxuryLevel ? "Save" : "Next"}
                </Button>
              </div>
            </form>
          </div>
        </List>
      </main>
    </>
  );
}

export default PackageMasterAdd;
